import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ReportHeader } from '../../header/report-header';
import { ReportExamSideBarFilter } from './side-bar-filter/report-exam-side-bar-filter';
import { ReportExamSideBarFilterDatamodel } from './side-bar-filter/report-exam-side-bar-filter-datamodel';
import { getExamReportOperation } from './operations/get-exam-report-operation';
import { ExamSessionReport } from '../../../../api/types/reports/education/exams/report-exam.types';
import dateUtils from '../../../../utils/date-format';
import { getExamStatusDisplayText } from '../../../../api/types/reports/education/exams/report-exam-statuses';

interface ExamData {
  branch: string;
  program: string;
  courseName: string;
  examType: string;
  examDate: string;
  session: string;
  step: string;
  status: string;
  registeredStudents: number;
  averageGrade: number | null;
}

export const ReportExams = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState<ReportExamSideBarFilterDatamodel>();

  const [examData, setExamData] = useState<ExamSessionReport[][]>([]);

  const handleFiltersChange = async (
    filters: ReportExamSideBarFilterDatamodel,
  ) => {
    // TODO: Implement filter logic

    setFilters(filters);
    await getExamReportOperation(setExamData, setLoading, filters);
    //await getExamReportOperation()
    console.log('Filters changed:', JSON.stringify(filters));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="דו״ח מבחנים"
        description="דו״ח זה מציג מידע מקיף על מבחנים בכל התכניות והקורסים. הדו״ח כולל נתונים על מועדי בחינה, סטטוס, ציונים ממוצעים ומספר נרשמים."
        metadata={[
          { label: 'מטרת הדו״ח', value: 'מעקב אחר מבחנים והישגים' },
          { label: 'תדירות עדכון', value: 'יומי' },
        ]}
        category="education"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <ReportExamSideBarFilter onSearch={handleFiltersChange} />
        </div>

        <div style={{ flex: 1 }}>
          <DataTable
            value={[...examData, ...examData]}
            rows={10}
            rowHover
            rowClassName={() => 'cursor-pointer'}
            rowsPerPageOptions={[5, 10, 20, 50]}
            emptyMessage={
              <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
            }
            dataKey="id"
            scrollable
            scrollHeight="calc(100vh - 230px)"
            tableStyle={{
              direction: 'rtl',
            }}
          >
            <Column
              field="branchName"
              header="שלוחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
            />
            <Column
              field="abstractProgramName"
              header="תכנית לימודים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
            />

            <Column
              field="programStartYear"
              header="שנת התחלה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
            />

            <Column
              field="annualSerialProgramNumber"
              header="מספר תוכנית בשנה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
            />
            <Column
              field="courseName"
              header="שם קורס"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
            />
            <Column
              field="examName"
              header="שם מבחן"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
            />
            <Column
              field="sessionDate"
              header="תאריך בחינה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
              body={(rowData: ExamSessionReport) => (
                <div>
                  <label>
                    {dateUtils.displayFormatDate(rowData.sessionDate)}
                  </label>
                </div>
              )}
            />

            <Column
              field="sessionDate"
              header="שעות בחינה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
              body={(rowData: ExamSessionReport) => (
                <div>
                  <label>
                    {dateUtils.formatTimeRangeBetweenDates(
                      rowData.sessionStartTime,
                      rowData.sessionEndTime,
                    )}
                  </label>
                </div>
              )}
            />
            <Column
              field="status"
              header="סטטוס"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              sortable
              body={(rowData: ExamSessionReport) => (
                <div>
                  <label>
                    {getExamStatusDisplayText(rowData.sessionStatus)}
                  </label>
                </div>
              )}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};
